import { Pages } from 'constants/menu'
import { SubPage } from 'components/left-submenu/LeftSubmenu'

export function getContractInformationSubPages(): SubPage[] {
  const subPages: SubPage[] = [
    {
      title: 'Sale Information',
      link: Pages.SALE_INFORMATION,
    },
    {
      title: 'Conditions',
      link: Pages.CONDITIONS,
    },
    {
      title: 'Special Conditions',
      link: Pages.SPECIAL_CONDITIONS,
    },
    {
      title: 'Settlement',
      link: Pages.SETTLEMENT,
    },
    {
      title: 'Deposits',
      link: Pages.DEPOSITS,
    },
  ]

  return subPages
}
